
import type { CartItem } from "@/context/CartContext";

interface CartPriceDetailsProps {
  items: CartItem[];
}

export const CartPriceDetails = ({ items }: CartPriceDetailsProps) => {
  const calculateSubtotal = (cartItems: CartItem[]) => {
    return cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  };

  const calculateTPS = (subtotal: number) => subtotal * 0.05;
  const calculateTVQ = (subtotal: number) => subtotal * 0.09975;

  const subtotal = calculateSubtotal(items);
  const tps = calculateTPS(subtotal);
  const tvq = calculateTVQ(subtotal);
  const total = subtotal + tps + tvq;

  return (
    <div className="space-y-2 sm:space-y-4 text-xs sm:text-sm">
      <div className="flex justify-between text-zinc-600">
        <span>Sous-total</span>
        <span className="font-medium text-zinc-900">{subtotal.toFixed(2)} CAD</span>
      </div>
      <div className="flex justify-between text-zinc-600">
        <span>TPS (5%)</span>
        <span className="font-medium text-zinc-900">{tps.toFixed(2)} CAD</span>
      </div>
      <div className="flex justify-between text-zinc-600">
        <span>TVQ (9.975%)</span>
        <span className="font-medium text-zinc-900">{tvq.toFixed(2)} CAD</span>
      </div>
      <div className="border-t border-zinc-200 pt-2 sm:pt-4 mt-2 sm:mt-4">
        <div className="flex justify-between items-baseline">
          <span className="text-sm sm:text-base font-medium text-zinc-900">Total</span>
          <span className="text-base sm:text-xl font-bold text-[#b82626]">{total.toFixed(2)} CAD</span>
        </div>
      </div>
    </div>
  );
};
